import { render, staticRenderFns } from "./UploadMultipleFiles.vue?vue&type=template&id=07546e7c"
import script from "./UploadMultipleFiles.vue?vue&type=script&lang=js"
export * from "./UploadMultipleFiles.vue?vue&type=script&lang=js"
import style0 from "./UploadMultipleFiles.vue?vue&type=style&index=0&id=07546e7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports